<template>
  <div id="app">
    <v-header />
    <div class="container">
      <v-menus class="aside-menu"></v-menus>
      <v-content />
    </div>
  </div>
</template>

<script>
import vHeader from './components/header';
import vMenus from './components/menus';
import vContent from './components/content';

export default {
  name: 'layout',

  components: {
    vHeader,
    vMenus,
    vContent,
  },

  data() {
    return {
      route: {}, //当前路由
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 88px;
  bottom: 24px;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}
</style>
